// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDeleteOutlinedSvg from "@fishx/icons-svg/es/asn/PDeleteOutlined";
import FishxIcon from '../components/FishxIcon';

var PDeleteOutlined = function PDeleteOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDeleteOutlinedSvg
  }));
};

PDeleteOutlined.displayName = 'PDeleteOutlined';
export default React.forwardRef(PDeleteOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDeleteOutlined.js
// module id = 3319
// module chunks = 0